import axios from "axios";
import auth from "../util/loginUtil";
import {toLogin} from "@/router/router";
import {Message} from "element-ui";

// axios 配置
axios.defaults.timeout = 400000;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers["Authorization"] = auth.getToken();
    config.headers["Pragma"] = "no-cache"; // 防止ie下get方法缓存
    return config;
  },
  err => {
    return Promise.reject(err);
  },
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.request.responseType === "blob") {
      return Promise.resolve(response);
    }
    let data = response.data;
    if (data) {
      return Promise.resolve(data);
    }
  },
  error => {
    console.log("-------------接口请求错误信息start-------------");
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        Message({
          showClose: true,
          message: "未认证或者认证过期，请重新登录",
          type: "error",
        });
        auth.logout();
        toLogin();
      }
      if (error.request.responseType === "blob") {
        const {data} = error.response;
        const reader = new FileReader();
        reader.onload = () => {
          const errorInfos = JSON.parse(reader.result);
          Message({
            showClose: true,
            message: "文件下载失败，" + errorInfos.message,
            type: "error",
          });
        };
        reader.onerror = err => {
          return Promise.reject(err);
        };
        reader.readAsText(data);
      } else {
        if (error.response.data.status === 404) {
          Message({
            showClose: true,
            message: "status:" + error.response.data.status + "，未找到接口:" + error.response.data.path,
            type: "error",
            duration: 8000,
          });
        }else {
          Message({
            showClose: true,
            message: "提示：" + error.response.data.message,
            type: "error",
            duration: 8000,
          });
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      Message({
        showClose: true,
        message: "连接服务器失败",
        type: "error",
        duration: 8000,
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      Message({
        showClose: true,
        message: "请求服务器出错",
        type: "error",
        duration: 8000,
      });
    }
    console.log("-------------接口请求错误信息end-------------");
    return Promise.reject(error);
  },
);

export default axios;
